import React, { useState, useCallback, useEffect } from "react";
import {AppMenu} from "./AppMenu";


interface DineXMProps {}

interface DineXMState {}

const DineXM: React.FC<DineXMProps> = ({}) => {           
    const [pageState, setPageState] = useState<DineXMState>(() => {});

    return(
        <>
        <AppMenu/>
        <div style={{minHeight: "300px"}}>Home</div>
        </>
    );
}

export default DineXM; 
